import { createContext, useContext } from "react";
import { WebViewContextType } from "./types";

export const WebViewContext = createContext<WebViewContextType | undefined>(
  undefined,
);
export const useWebView = (): WebViewContextType => {
  const context = useContext(WebViewContext);
  if (!context) throw new Error("useWebView usato fuori dal provider");
  return context;
};
